import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'

class FormComplainDescription extends Component {
    constructor(props) {
        super(props)
        console.log("Fdes")
    }
    render(){
        const putOption = (option) => {
            return <option key={option._id} value={option._id}>{option.name}</option>
        }

        return(
            <div className="container">
                <div className="row">
                    <div className="col-sm-6 col-md-10 col-lg-6">
                        <select id="reason" className="form-control" required>
                            {this.props.reasons.map(putOption)}
                            <option value="" disabled selected hidden>Motivo*</option>
                        </select>
                    </div>
                    <div className="col-sm-6 col-md-10 col-lg-6">
                        <select id="stage" className="form-control" required>
                            {this.props.stages.map(putOption)}
                            <option value="" disabled selected hidden>Etapa del proceso*</option>
                        </select>
                    </div>
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <textarea id="description" className="form-control" placeholder="Comentario*" required></textarea>
                    </div>
                </div>
            </div>
        )
    }
}

export default FormComplainDescription


// WEBPACK FOOTER //
// ./src/components/FormComplainDescription/FormComplainDescription.js